
export enum NjLoaderSize{
    XSMALL="XS",
    SMALL="S",
    MEDIUM="M",
    LARGE="L",
    XLARGE="XL"
}